<template>
  <div>
    <EventForm
      title="Attend this event"
      subtitle="You have already registered for this event."
      submit-text="Attend event"
      :no-inputs="eventsEmailExists"
      :on-apply-now="toggleApplyNowModal"
      :on-submit="onSubmit"
    />
    <Modals
      :toggle-apply-now="toggleApplyNowModal"
      :toggle-success="toggleSuccessModal"
      :show-apply-now="showApplyNowModal"
      :show-success="showSuccessModal"
    />
  </div>
</template>

<script>
import EventForm from '../EventForm/EventForm.vue';
import Modals from '../Modals/Modals.vue';

export default {
  components: { EventForm, Modals },
  props: {
    eventLink: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showApplyNowModal: false,
      showSuccessModal: false,
      eventsEmailExists: false,
    };
  },
  mounted() {
    this.eventsEmailExists =
      this.$localStorage.getItem('events_email') !== null;
  },
  methods: {
    toggleApplyNowModal() {
      this.showApplyNowModal = !this.showApplyNowModal;
    },
    toggleSuccessModal() {
      this.showSuccessModal = !this.showSuccessModal;
    },
    onSubmit() {
      window.open(this.eventLink, '_blank');
    },
  },
};
</script>
